jQuery('#relatedProjectsSlider').slick({
    dots: false,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: jQuery(".related-projects .prev-arrow"),
    nextArrow: jQuery(".related-projects .next-arrow"),
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 520,
            settings: {
                slidesToShow: 1,
            }
        },
    ]
});